import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Email Template',
    entityNamePlural: 'Email Templates',
    entityNameModule: 'settings',
    basePath: '/settings/email-templates',
  }), [])
}
